/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useState } from "react";
import { SketchPicker } from "react-color";
import { useRecoilValue } from "recoil";
import { InternalUserAtom } from "../../../../../atoms/UserAtom";
import { IUserIRoute } from "../../../../../generated/Api";
import useClickOutside from "../../../../../hook/useClickOutside";
import { SpaceBetween } from "../../../../../styles/general";
import Switch from "../../../../Switch";

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 25px 0px;
  padding: 0px 22px;
  width: 600px;
  height: fit-content;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

const Title = styled.div`
  color: #2f2f2f;
  font-weight: 600;
  margin-bottom: 5px;
`;

const ButtonSelect = styled.div`
  width: 80px;
  height: 30px;
  border: 1px solid #dddddd;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  position: relative;
`;

const ColorSelect = styled.div`
  width: 100%;
  height: 100%;
`;

const ColorPickerContainer = styled.div`
  position: absolute;
  bottom: 50px;
  right: 0;
  z-index: 20;
`;

const SubjectDescpription = styled.div`
  color: #707070;
  font-size: 14px;
`;

interface Props {
  user: IUserIRoute;
  setUser: (u: IUserIRoute) => void;
}

export default function LinkColorPicker(props: Props) {
  const { user, setUser } = props;
  const internalUser = useRecoilValue(InternalUserAtom);
  const [openDefaultColorPicker, setOpenDefaultColorPicker] = useState(false);
  const [openDarkColorPicker, setOpenDarkColorPicker] = useState(false);
  const colorPickerRef = useClickOutside(() => {
    setOpenDefaultColorPicker(false);
  });

  /**
   * Temporary code to allow only Troy's accounts to use this.
   * It's better to have a phone in the source code than UIDs
   */
  // if (
  //   (user &&
  //     !["5511966401241", "14343730297", "14074320801"].includes(user.phone)) ||
  //   (internalUser &&
  //     !["5511966401241", "14343730297", "14074320801"].includes(
  //       internalUser.phone
  //     ))
  // )
  //   return null;

  return (
    <FlexColumn>
      <Title>Link Preferences</Title>
      <SpaceBetween
        css={css`
          margin-bottom: 15px;
        `}
      >
        <SubjectDescpription>Automatically make links bold</SubjectDescpription>

        <Switch
          toggled={!!user.emailOptions.autoBoldLinks}
          whenToggled={async (vle) => {
            setUser({
              ...user,
              emailOptions: {
                ...user.emailOptions,
                autoBoldLinks: vle,
              },
            });
          }}
        />
      </SpaceBetween>
      <SpaceBetween
        css={css`
          margin-bottom: 15px;
        `}
      >
        <SubjectDescpription>Link Color</SubjectDescpription>
        <ButtonSelect ref={colorPickerRef}>
          <ColorSelect
            css={css`
              background-color: ${user.emailOptions.defaultModeColorLink};
            `}
            onClick={() => setOpenDefaultColorPicker(!openDefaultColorPicker)}
          />

          {openDefaultColorPicker && (
            <ColorPickerContainer
              css={css`
                .sketch-picker > .flexbox-fix:nth-child(3) > div > div {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                }
              `}
            >
              <SketchPicker
                presetColors={[]}
                disableAlpha
                color={user.emailOptions.defaultModeColorLink}
                onChangeComplete={(c) =>
                  setUser({
                    ...user,
                    emailOptions: {
                      ...user.emailOptions,
                      defaultModeColorLink: c.hex,
                    },
                  })
                }
              />
            </ColorPickerContainer>
          )}
        </ButtonSelect>
      </SpaceBetween>

      {/* <SpaceBetween
        css={css`
          margin-bottom: 15px;
        `}
      >
        <SubjectDescpription>Dark Mode</SubjectDescpription>
        <ButtonSelect>
          <ColorSelect
            onClick={() => setOpenDarkColorPicker(!openDarkColorPicker)}
            css={css`
              background-color: ${user.emailOptions.darkModeColorLink};
            `}
          />

          {openDarkColorPicker && (
            <ColorPickerContainer>
              <SketchPicker
                presetColors={[]}
                disableAlpha
                color={user.emailOptions.darkModeColorLink}
                onChangeComplete={(c) =>
                  setUser({
                    ...user,
                    emailOptions: {
                      ...user.emailOptions,
                      darkModeColorLink: c.hex,
                    },
                  })
                }
              />
            </ColorPickerContainer>
          )}
        </ButtonSelect>
      </SpaceBetween> */}
    </FlexColumn>
  );
}
